<script lang="ts">
  let {
    width = 150,
    notchSize = 10,
    notchNum = 100,
    circleRatio = 0.7,
    colors = [
      { stop: 0, color: 'blue' },
      { stop: 50, color: 'orange' },
      { stop: 100, color: 'green' },
    ],
  }: {
    width: number;
    notchSize: number;
    notchNum: number;
    circleRatio: number;
    colors: { stop: number; color: string }[];
  } = $props();

  let id = 'circle-mask-' + Math.floor(Math.random() * 1000000);
  const radius = $derived(width / 2 - notchSize / 2);
  const circumference = $derived(2 * Math.PI * radius);
  const length = $derived(circleRatio * circumference);
  const rotation = $derived(90 + (1 - circleRatio) * 180);
  const notchWidth = $derived(length / (notchNum * 2 - 1));
  const center = $derived(width / 2);
  let dashArrayValues: number[] = [];
  let dashArray: string = $state('');
  let gradientString = $derived(makeGradientString(colors, circleRatio));

  $effect(() => {
    dashArrayValues = [];
    for (let i = 0; i < notchNum * 2; i++) {
      dashArrayValues.push(notchWidth);
    }
    dashArrayValues.pop();
    dashArrayValues.push(circumference - length);
    dashArray = dashArrayValues.join(' ');
  });

  const transform = $derived(`rotate(${rotation} ${center} ${center})`);
  function makeGradientString(colors: { stop: number; color: string }[], circleRatio: number) {
    let string = colors
      .map((color) => {
        return `${color.color} ${color.stop * circleRatio * 3.6}deg`;
      })
      .join(', ');
    return `conic-gradient(from ${180 + ((1 - circleRatio) / 2) * 360}deg, ${string})`;
  }
  // function getNotchAngle(i: number) {
  //   return rotation + ((circleRatio * 360) / (notchNum - 0.5)) * i;
  // }
</script>

<div
  style={`width: ${width}px; height: ${width}px; background: ${gradientString};mask: url(#${id});`}
></div>
<svg class="h-0 w-0" xmlns="http://www.w3.org/2000/svg">
  <mask {id}>
    <rect width="100%" height="100%" fill="black" />
    <circle
      cx={center}
      cy={center}
      r={radius}
      fill="none"
      stroke="white"
      stroke-width={notchSize}
      stroke-dasharray={dashArray}
      {transform}
    />
  </mask>
</svg>
